/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * File of another borrower attached to the same loan project (co-borrower)
 * @export
 * @interface BorrowerOtherFileDto
 */
export interface BorrowerOtherFileDto {
    /**
     * Unique identifier of the co-borrower contract
     * @type {string}
     * @memberof BorrowerOtherFileDto
     */
    contractId: string;
    /**
     * Contract number of the co-borrower contract
     * @type {string}
     * @memberof BorrowerOtherFileDto
     */
    contractNumber?: string | null;
    /**
     * File number of the co-borrower
     * @type {string}
     * @memberof BorrowerOtherFileDto
     */
    fileNumber?: string | null;
    /**
     * Last name of the co-borrower
     * @type {string}
     * @memberof BorrowerOtherFileDto
     */
    lastName?: string | null;
    /**
     * First name of the co-borrower
     * @type {string}
     * @memberof BorrowerOtherFileDto
     */
    firstName?: string | null;
    /**
     * Contract status label
     * @type {string}
     * @memberof BorrowerOtherFileDto
     */
    status?: string | null;
    /**
     * Contract status code
     * @type {string}
     * @memberof BorrowerOtherFileDto
     */
    statusCode?: string | null;
}

/**
 * Check if a given object implements the BorrowerOtherFileDto interface.
 */
export function instanceOfBorrowerOtherFileDto(value: object): value is BorrowerOtherFileDto {
    if (!('contractId' in value) || value['contractId'] === undefined) return false;
    return true;
}

export function BorrowerOtherFileDtoFromJSON(json: any): BorrowerOtherFileDto {
    return BorrowerOtherFileDtoFromJSONTyped(json, false);
}

export function BorrowerOtherFileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerOtherFileDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contractId': json['contractId'],
        'contractNumber': json['contractNumber'] == null ? undefined : json['contractNumber'],
        'fileNumber': json['fileNumber'] == null ? undefined : json['fileNumber'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'status': json['status'] == null ? undefined : json['status'],
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
    };
}

export function BorrowerOtherFileDtoToJSON(json: any): BorrowerOtherFileDto {
    return BorrowerOtherFileDtoToJSONTyped(json, false);
}

export function BorrowerOtherFileDtoToJSONTyped(value?: BorrowerOtherFileDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contractId': value['contractId'],
        'contractNumber': value['contractNumber'],
        'fileNumber': value['fileNumber'],
        'lastName': value['lastName'],
        'firstName': value['firstName'],
        'status': value['status'],
        'statusCode': value['statusCode'],
    };
}

